import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { UserData } from '../Models/employee-and-user-data';

@Injectable({
  providedIn: 'root',
})
export class SessionvalidateService {
  userdata?: UserData;
  currentdate: string | undefined;
  CurrentTime: string | undefined;

  validate() {
    //this.currentdate = moment().toDate();
    this.currentdate = moment().format(moment.HTML5_FMT.DATE);
    this.CurrentTime = moment().format(moment.HTML5_FMT.TIME_SECONDS);
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    if (localStorage.getItem('userinfo') == null) return false;
    const timeFormat = 'HH:mm:ss';
    const sessionStart = this.userdata?.packagePckgBeg ?? this.userdata?.pckgBeg;
    const sessionEnd = this.userdata?.packageCruiseEnd ?? this.userdata?.cruiseEnd;
    if (moment(moment(sessionStart).format(moment.HTML5_FMT.DATE)
      ).subtract(14, 'days').isSameOrBefore(this.currentdate) &&

      (moment(moment(sessionEnd).format(moment.HTML5_FMT.DATE)
      ).isAfter(this.currentdate) ||

      (moment(moment(sessionEnd).format(moment.HTML5_FMT.DATE)
      ).isSame(this.currentdate) &&
      moment(this.CurrentTime, timeFormat).isBefore(moment('8:00:00', timeFormat))))
    ) {
      return true;
    }
    else {
      this.expire();
      return false;
    }
  }
  expire() {
    localStorage.removeItem('userinfo');
  }
}
